import { useQuery } from "react-query";

import { confirmationService } from "services";

type UseCancelEmailChangeQueryProps = {
	token: string | null;
	setHasError: Function;
};

const useCancelEmailChangeQuery = ({
	token,
	setHasError,
}: UseCancelEmailChangeQueryProps) => {
	const queryResult = useQuery(
		["cancelEmailChange", token],
		() =>
			confirmationService.cancelEmailChange({
				token,
			}),
		{
			onSuccess() {
				setHasError(false);
			},
			onError() {
				setHasError(true);
			},
			enabled: !!token,
			cacheTime: 0,
			retry: false,
		},
	);

	return queryResult;
};

export default useCancelEmailChangeQuery;
